import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {DynamicTransactionTypeAuthGuard} from '@app/checkout/guards/dynamic-transaction-type-auth.guard';
import {UserRegistrationGuard} from '@app/checkout/guards/user-registration.guard';
import {
  DcpConfiguratorSinglePageFormModule,
  DCPOccConfiguratorVariantAddToCartSerializer,
  DCPOccConfiguratorVariantNormalizer,
  DcpOccConfiguratorVariantSerializer,
  DcpOccConfiguratorVariantUpdateCartEntrySerializer,
  DcpRulebasedConfiguratorConnector,
  de,
  en,
  StepInputService,
  UrlParamsGuard,
} from '@dcp/configurator';
import {CmsConfig, I18nConfig, provideConfig, TranslatePipe} from '@spartacus/core';
import {
  configuratorTranslationChunksConfig,
  configuratorTranslations,
} from '@spartacus/product-configurator/common/assets';
import {
  ConfiguratorAttributeQuantityModule,
  ConfiguratorPriceModule,
  OccConfiguratorVariantNormalizer,
  OccConfiguratorVariantSerializer,
  RulebasedConfiguratorConnector,
  VARIANT_CONFIGURATOR_ADD_TO_CART_SERIALIZER,
  VARIANT_CONFIGURATOR_UPDATE_CART_ENTRY_SERIALIZER,
} from '@spartacus/product-configurator/rulebased';
import {RulebasedConfiguratorRootModule} from '@spartacus/product-configurator/rulebased/root';
import {IconModule, KeyboardFocusModule} from '@spartacus/storefront';
import {ModalModule, TooltipModule} from 'ng-design-system';
import {CustomDcpConfiguratorSinglePageFormComponent} from './dcp-configurator-single-page-form/custom-dcp-configurator-single-page-form.component';
import {SuccessUrlGuard} from '@app/checkout/guards/success-url.guard';
import {BackUrlGuard} from '@app/checkout/guards/back-url.guard';

@NgModule({
  declarations: [],
  imports: [
    RulebasedConfiguratorRootModule,
    ConfiguratorPriceModule,
    KeyboardFocusModule,
    ReactiveFormsModule,
    ConfiguratorAttributeQuantityModule,
    DcpConfiguratorSinglePageFormModule,
    CommonModule,
    IconModule,
    ModalModule,
    TooltipModule,
  ],
  exports: [],
  providers: [
    StepInputService,
    TranslatePipe,
    {
      provide: OccConfiguratorVariantNormalizer,
      useClass: DCPOccConfiguratorVariantNormalizer,
    },
    {
      provide: OccConfiguratorVariantSerializer,
      useClass: DcpOccConfiguratorVariantSerializer,
    },
    {
      provide: RulebasedConfiguratorConnector,
      useClass: DcpRulebasedConfiguratorConnector,
    },
    {
      provide: VARIANT_CONFIGURATOR_ADD_TO_CART_SERIALIZER,
      useExisting: DCPOccConfiguratorVariantAddToCartSerializer,
      multi: true,
    },
    {
      provide: VARIANT_CONFIGURATOR_UPDATE_CART_ENTRY_SERIALIZER,
      useExisting: DcpOccConfiguratorVariantUpdateCartEntrySerializer,
      multi: true,
    },
    provideConfig({
      i18n: {
        resources: configuratorTranslations,
        chunks: configuratorTranslationChunksConfig,
      },
    } as I18nConfig),
    provideConfig({
      i18n: {
        resources: {
          en: {
            configurator: en,
          },
          de: {
            configurator: de,
          },
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        ConfiguratorForm: {
          component: CustomDcpConfiguratorSinglePageFormComponent,
          guards: [
            UrlParamsGuard,
            DynamicTransactionTypeAuthGuard,
            UserRegistrationGuard,
            SuccessUrlGuard,
            BackUrlGuard,
          ],
        },
      },
    } as CmsConfig),
  ],
})
export class DcpCpsProductConfiguratorModule {}
